// What a rejected API call means, for the sign-out handling in every API client.
// Staff: 401 or 403 ends the session, and they sign in on the login page.
// Prod_US phone session: only 401 does. A 403 is a real answer ("No credits left"),
// and that person signs in again at their own entry page, not the staff login.
import { PROD_US_HOME } from "../routes/routerPath";

const SESSION_KEY = "mmtSession";

const isPhoneSession = () => {
  try {
    const session = JSON.parse(
      sessionStorage.getItem(SESSION_KEY) ||
        localStorage.getItem(SESSION_KEY) ||
        "null",
    );
    return session?.customer_type === "prod_us";
  } catch {
    return false;
  }
};

export const isSessionRejected = (status) =>
  status === 401 || (status === 403 && !isPhoneSession());

// Read before the session is cleared.
export const signInUrl = (locale) =>
  isPhoneSession() ? PROD_US_HOME : `/login?locale=${locale || "en"}`;
